export const ThemeColors = {
  'custom-base-load': '--color-custom-base-load',
  'custom-border-muted': '--color-custom-border-muted',
  'custom-asset-overview-poc-circle': '--color-custom-asset-overview-poc-circle',
  'custom-asset-overview-dot-fill': '--color-custom-asset-overview-dot-fill',
  'custom-secondary-border': '--color-custom-secondary-border',
  'custom-success': '--color-custom-success',
  'custom-error': '--color-custom-error',
  'custom-ready': '--color-custom-ready',
  'custom-charging': '--color-custom-charging',
  'custom-queued': '--color-custom-queued',
  'custom-faulted': '--color-custom-faulted',
  'custom-soc-doughnut-dash': '--color-custom-soc-doughnut-dash',
  'custom-timeline-scrollbar-track': '--color-custom-timeline-scrollbar-track',
  'custom-disabled-input-background': '--color-custom-disabled-input-background',
  'custom-disabled-input-color': '--color-custom-disabled-input-color',
  'custom-disabled-card': '--color-custom-disabled-card',
  'custom-disabled-card-text': '--color-custom-disabled-card-text',
  'custom-net-profit': '--color-custom-net-profit',
  'custom-net-profit-disabled': '--color-custom-net-profit-disabled',
  'custom-flex-drill-down-date-highlight': '--color-custom-flex-drill-down-date-highlight',
  'custom-trading-table-edited-cell': '--color-custom-trading-table-edited-cell',
  'custom-trading-table-selected-overlay': '--color-custom-trading-table-selected-overlay',
  'session-outcome-completed': '--color-session-outcome-completed',
  'session-outcome-short': '--color-session-outcome-short',
  'session-outcome-incomplete': '--color-session-outcome-incomplete',
  'session-outcome-short-and-incomplete': '--color-session-outcome-short-and-incomplete',
  'session-outcome-faulted': '--color-session-outcome-faulted',
  'session-outcome-short-and-faulted': '--color-session-outcome-short-and-faulted',
  'vehicle-telemetry-never-reported': '--color-vehicle-telemetry-never-reported',
  'vehicle-telemetry-offline-3-plus-days': '--color-vehicle-telemetry-offline-3-plus-days',
  'vehicle-telemetry-offline-1-to-2-days': '--color-vehicle-telemetry-offline-1-to-2-days',
  'vehicle-telemetry-offline-over-12-hours': '--color-vehicle-telemetry-offline-over-12-hours',
  'vehicle-telemetry-intermittent': '--color-vehicle-telemetry-intermittent',

  'background-main': '--color-background-main',
  'background-fixed': '--color-background-fixed',
  'background-moveable': '--color-background-moveable',
  'background-menu': '--color-background-menu',
  'background-panel': '--color-background-panel',
  'background-container-primary': '--color-background-container-primary',
  'background-container-primary-50': '--color-background-container-primary-50',
  'background-container-secondary': '--color-background-container-secondary',
  'background-container-inverse': '--color-background-container-inverse',
  'background-container-tertiary': '--color-background-container-tertiary',
  'background-border': '--color-background-border',

  'foreground-primary-100': '--color-foreground-primary-100',
  'foreground-primary-80': '--color-foreground-primary-80',
  'foreground-primary-60': '--color-foreground-primary-60',
  'foreground-primary-40': '--color-foreground-primary-40',
  'foreground-primary-20': '--color-foreground-primary-20',
  'foreground-primary-12': '--color-foreground-primary-12',
  'foreground-primary-8': '--color-foreground-primary-8',
  'foreground-secondary-100': '--color-foreground-secondary-100',
  'foreground-secondary-80': '--color-foreground-secondary-80',
  'foreground-secondary-60': '--color-foreground-secondary-60',
  'foreground-secondary-40': '--color-foreground-secondary-40',
  'foreground-secondary-20': '--color-foreground-secondary-20',
  'foreground-secondary-12': '--color-foreground-secondary-12',
  'foreground-secondary-8': '--color-foreground-secondary-8',

  'action-primary': '--color-action-primary',
  'action-primary-30': '--color-action-primary-30',
  'action-primary-20': '--color-action-primary-20',
  'action-primary-text': '--color-action-primary-text',
  'action-secondary': '--color-action-secondary',
  'action-secondary-30': '--color-action-secondary-30',
  'action-secondary-18': '--color-action-secondary-18',
  'action-secondary-text': '--color-action-secondary-text',

  'chargingstatus-foreground': '--color-chargingstatus-foreground',
  'chargingstatus-ready-100': '--color-chargingstatus-ready-100',
  'chargingstatus-ready-80': '--color-chargingstatus-ready-80',
  'chargingstatus-ready-30': '--color-chargingstatus-ready-30',
  'chargingstatus-charging-100': '--color-chargingstatus-charging-100',
  'chargingstatus-charging-80': '--color-chargingstatus-charging-80',
  'chargingstatus-charging-30': '--color-chargingstatus-charging-30',
  'chargingstatus-queued-100': '--color-chargingstatus-queued-100',
  'chargingstatus-queued-80': '--color-chargingstatus-queued-80',
  'chargingstatus-queued-30': '--color-chargingstatus-queued-30',
  'chargingstatus-faulted-100': '--color-chargingstatus-faulted-100',
  'chargingstatus-faulted-80': '--color-chargingstatus-faulted-80',
  'chargingstatus-faulted-30': '--color-chargingstatus-faulted-30',
  'chargingstatus-indepot-100': '--color-chargingstatus-indepot-100',
  'chargingstatus-indepot-80': '--color-chargingstatus-indepot-80',
  'chargingstatus-indepot-30': '--color-chargingstatus-indepot-30',
  'chargingstatus-onroad-100': '--color-chargingstatus-onroad-100',
  'chargingstatus-onroad-80': '--color-chargingstatus-onroad-80',
  'chargingstatus-onroad-30': '--color-chargingstatus-onroad-30',
  'chargingstatus-unknown-100': '--color-chargingstatus-unknown-100',
  'chargingstatus-unknown-80': '--color-chargingstatus-unknown-80',
  'chargingstatus-unknown-30': '--color-chargingstatus-unknown-30',

  'chart-ev': '--color-chart-ev',
  'chart-baseload': '--color-chart-baseload',
  'chart-pv-solar': '--color-chart-pv-solar',
  'chart-grid': '--color-chart-grid',
  'chart-battery': '--color-chart-battery',
  'chart-physical-notification': '--color-chart-physical-notification',
  'chart-gross-revenue': '--color-chart-gross-revenue',
  'chart-net-revenue': '--color-chart-net-revenue',

  'header-title': '--color-header-title',
  'header-breadcrumb-current': '--color-header-breadcrumb-current',
  'header-breadcrumb-past': '--color-header-breadcrumb-past',
  'header-tab-text': '--color-header-tab-text',
  'header-tab-text-80': '--color-header-tab-text-80',
  'header-tab-text-30': '--color-header-tab-text-30',
  'header-tab-text-22': '--color-header-tab-text-22',
  'header-tab-line': '--color-header-tab-line',
  'header-actionitem-bg': '--color-header-actionitem-bg',
  'header-actionitem-bg-50': '--color-header-actionitem-bg-50',
  'header-actionitem-fg': '--color-header-actionitem-fg',

  'status-success': '--color-status-success',
  'status-success-30': '--color-status-success-30',
  'status-success-text': '--color-status-success-text',
  'status-error': '--color-status-error',
  'status-error-30': '--color-status-error-30',
  'status-error-20': '--color-status-error-20',
  'status-error-0': '--color-status-error-0',
  'status-error-text': '--color-status-error-text',
  'status-warning': '--color-status-warning',
  'status-warning-30': '--color-status-warning-30',
  'status-warning-text': '--color-status-warning-text',
  'status-info': '--color-status-info',
  'status-info-30': '--color-status-info-30',
  'status-info-text': '--color-status-info-text',
  'status-idle': '--color-status-idle',
  'status-offline': '--color-status-offline',
  'status-offline-30': '--color-status-offline-30',
  'status-offline-text': '--color-status-offline-text',

  'risk-band-low': '--color-risk-band-low',
  'risk-band-low-20': '--color-risk-band-low-20',
  'risk-band-moderate': '--color-risk-band-moderate',
  'risk-band-moderate-20': '--color-risk-band-moderate-20',
  'risk-band-high': '--color-risk-band-high',
  'risk-band-high-20': '--color-risk-band-high-20',
  'risk-band-not-enough-data': '--color-risk-band-not-enough-data',
  'risk-band-not-enough-data-20': '--color-risk-band-not-enough-data-20',
  'risk-band-not-operational': '--color-risk-band-not-operational',
  'risk-band-not-operational-20': '--color-risk-band-not-operational-20',

  'trip-health-good': '--color-trip-health-good',
  'trip-health-warning': '--color-trip-health-warning',
  'trip-health-error': '--color-trip-health-error',

  'stroke-primary': '--color-stroke-primary',
  'stroke-primary-8': '--color-stroke-primary-8',
  'stroke-card-border': '--color-stroke-card-border',
  'stroke-container': '--color-stroke-container',
  'stroke-action': '--color-stroke-action',
  'stroke-tertiary': '--color-stroke-tertiary',
  'stroke-tertiary-16': '--color-stroke-tertiary-16',
} as const;
